import numbro from 'numbro';


export function getRawValue(value?: string|number){
  const v = typeof value === 'string'? value : value?.toString?.();
  return v?.replaceAll(',', '')?? '';
}

export function simpleThousanded(value?: string|number){
  if(value === undefined || value === null) return '';
  if(!value || isNaN(Number(value))) return value;
  return numbro(value).format({thousandSeparated: true});
}